import { createSelector } from '@reduxjs/toolkit';
import { selectOrder } from '../../selectors';

export const selectSearch = createSelector(selectOrder, (orderState) => orderState.search);
export const selectParameters = createSelector(selectSearch, (searchState) => searchState.parameters);
export const selectSecurities = createSelector(selectSearch, (searchState) => searchState.securities);
export const selectSearchResults = createSelector(selectSearch, (searchState) => searchState.results);
export const selectSearchSelectedResults = createSelector(selectSearch, (searchState) => searchState.selectedResults);
export const selectModels = createSelector(selectSearch, (searchState) => searchState.models);
